export default {
  'navigation.drawer_user_info.drawer_user_detail.team_clipboard_text':
    'Copy Team ID',
  'navigation.drawer_user_info.drawer_user_detail.company_clipboard_text':
    'Copy Company ID',
  'navigation.header_alert.message_trial':
    'Your trial will end in {{dayString}}. Verify upcoming entitlements are in place to avoid a lapse in service.',
  'navigation.header_alert.message_entitlements':
    'Your entitlements will end in {{dayString}}. Verify upcoming entitlements are in place to avoid a lapse in service.',
  'navigation.header_alert.action': 'Contact Sales'
}
